import React from 'react';
import { bg0, bg1, bg2 } from '@osmosis/tailwind-ui/styles/background';
import { textPrimary } from '@osmosis/tailwind-ui/styles/text';
import { borderColor100 } from '@osmosis/tailwind-ui/styles/border';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { H4 } from '@osmosis/tailwind-ui/components/Text';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faPlayCircle } from '@fortawesome/pro-solid-svg-icons/faPlayCircle';

type Props = {
  onClick: () => void;
  src?: string;
  name: string;
  'data-testid': string;
  isVideo?: boolean;
  icon?: IconDefinition;
};

/** Card to display with an image. */
const NextUpCard = (props: Props) => {
  const { onClick, icon, src, name, isVideo = false } = props;

  const hoverBg = `hover:${bg1}`;
  const activeBg = `active:${bg2}`;
  return (
    <Box
      data-testid={props['data-testid']}
      onClick={onClick}
      className={`cursor-pointer ${bg0} ${hoverBg} ${activeBg} transition-all duration-100 ease-in-out rounded-[5px] overflow-hidden w-full md:w-[200px]`}
    >
      <Box className="hidden md:block w-full max-h-[100px] relative overflow-hidden">
        {isVideo && (
          <Flex className="absolute w-full h-full justify-center items-center text-[32px] opacity-75">
            <Icon icon={faPlayCircle} />
          </Flex>
        )}

        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img width="100%" src={src} />
      </Box>
      <Flex className={`p-2 px-3 border-t gap-2 ${borderColor100}`}>
        {icon && (
          <Box className={textPrimary}>
            <Icon className="text-xl" icon={icon} />
          </Box>
        )}

        <H4>{name}</H4>
      </Flex>
    </Box>
  );
};

export default NextUpCard;
